import React from "react";
import { HashRouter as Router, Route, Routes } from "react-router-dom";
// import Header from "../shared/components/Header/Header";
import BlogHome from "./components/BlogHome/BlogHome";
import Footer from "../shared/components/Footer/Footer";
import "./index.css";
import DarkMode from "../shared/components/DarkMode/DarkMode";

function Blog() {
  return (
    <div className="app">
      {/* <Header /> */}
     <DarkMode />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<BlogHome />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default Blog;
